import React,  { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "../styles/verifynotification.css";
import { stickyNotification } from "../utils/common";

const VerifyNotification = (props) => {
  const history = useHistory();
  const [user] = useState(useSelector( state => state.user));
  const requestNewVerification = () => {
    history.push(`/verify?sendverification=true&uid=${user.uid}`);
  };

  useEffect( () => {
    let notification = document.getElementById("verification-main-wrapper");
    let sticky = notification?.offsetHeight;
    window.onscroll = function() {stickyNotification(window, sticky, notification)};
  }, [])

  return (
    <div className="verification-notice-container" data-testid="verification-main-wrapper" id="verification-main-wrapper">
      <div className="notice-text">
        <div className="notice-text-label">Your email is not verified. </div>
        <button className="new-verify-cta" onClick={requestNewVerification} data-testid="verify-cta">
          Verify
        </button>
      </div>
      <div className="close-icon" onClick={props.closeNotification} data-testid="closeNotification">
        <span aria-hidden="true">&times;</span>
      </div>
    </div>
  );
};

export default VerifyNotification;
